import { Component, Input, OnInit, SimpleChanges, TemplateRef, ViewChild } from "@angular/core";
import { ITableModel } from "../../../shared/components/table/model/tableModel";
import { environment } from "../../../../environments/environment";
import { appService } from "../../../_services/app.service";
import { ToastrService } from "ngx-toastr";
import { Helpers } from "../../../helpers";
import { ScriptLoaderService } from "../../../../app/_services/script-loader.service";
import { PrintFormatsComponent } from "../../../print-formats/print-formats.component";
import { CookieService } from "ngx-cookie-service";
import { DecryptPipe } from "./../../../auth/_services/encrypt-decrypt.pipe";
import { OrdersService } from "../../services/orders/orders.service";
import { Router } from "@angular/router";

@Component({
  selector: 'app-quotationlog',
  templateUrl: './quotationlog.component.html',
  styleUrls: ['./quotationlog.component.scss']
})
export class QuotationlogComponent implements OnInit {

  tableDetails: ITableModel;
  @Input() IndentId:any;

  constructor(
    private _appService: appService,
    private toastr: ToastrService,
    private _script: ScriptLoaderService,
    private cookieService: CookieService,
    private decryptpipe: DecryptPipe,
    private orderService: OrdersService,
  ) { }

  ngOnInit() {
    this.Initialize();
    this.GetQuotationLogList(this.IndentId);
  }


  ngOnChanges(changes: SimpleChanges) {
    if (changes['IndentId']) {
      this.GetQuotationLogList(this.IndentId);
    }
  }

  async Initialize() {
  this.tableDetails = {
      emptyDataMSg: "Log is Empty.",
      data: [],
      columnDetails: [
        { columnName: "Date", dataFieldName: "INDate" },
        { columnName: "Users", dataFieldName: "CustomerName" },
        { columnName: "Status", dataFieldName: "Status" },
        { columnName: "Reason", dataFieldName: "Reason" },
        { columnName: "Remark", dataFieldName: "Remark" },
        { columnName: "Amount", dataFieldName: "TotalAmount" },
      ],
      actionList: [],
      isColumnNameShow: true,
      isShowFooterData: false,
    };
  }

  GetQuotationLogList(Id){
    let obj:any={};
    obj.Id=Id;
    this._appService.Post('OrdersByVehicle','GetQuotationLogList',obj).subscribe(
      (response)=>{
        if(response){
          this.tableDetails.data = response
        }
      },
      (error)=>{
        this.toastr.error('Error while getting Quotation List','Error');
      }
    );
  }

}
